<template>
    <Dropdown
        class="DshDropdown"
        :trigger="trigger"
        :placement="placement"
        :transfer="transfer"
    >
        <slot>
            <Icon
                class="DshDropdown-rel"
                :type="dropdownObj.icon"
                :size="dropdownObj.size"
                :color="dropdownObj.color"
            />
        </slot>

        <DropdownMenu
            v-if="list.length"
            slot="list"
            :class="['DshDropdown-list', menuClass]"
        >
            <slot name="DropdownMenu">
                <DropdownItem
                    v-for="dropdownItem in list"
                    :key="dropdownItem._id || dropdownItem.type"
                    :class="{
                        'DshDropdown-list-item': true,
                        'disabled': dropdownItem.disabled
                    }"
                    :name="dropdownItem.name"
                    :disabled="dropdownItem.disabled"
                    :divided="dropdownItem.divided"
                    :selected="dropdownItem.selected"
                    @click.native.stop="dispatchEvent(dropdownItem)"
                >
                    <slot
                        name="dropdownItem"
                        :dropdownItem="dropdownItem"
                    >
                        <dsh-icons
                            v-if="dropdownObj.showDropdownItemIcon !== false"
                            :class="{
                                'DshDropdown-list-item-icon': true,
                                'disabled': dropdownItem.disabled
                            }"
                            :list="[dropdownItem]"
                        />
                        <span :class="{
                            'DshDropdown-list-item-name': true,
                            'disabled': dropdownItem.disabled
                        }">{{ dropdownItem.name || dropdownItem._name }}</span>
                    </slot>
                </DropdownItem>
            </slot>
        </DropdownMenu>
    </Dropdown>
</template>

<script>
    export default {
        name: "DshDropdown",
        props: {
            dropdownObj: {
                type: Object,
                default () {
                    return {
                        icon: "ios-more",
                        size: 18,
                        showDropdownItemIcon: true
                    };
                }
            },
            list: {
                type: Array,
                default () {
                    return [];
                }
            },
            placement: {
                type: String,
                default: "bottom-start"
            },
            trigger: {
                type: String,
                default: "hover"
            },
            transfer: {
                type: Boolean,
                default: true
            },
            menuClass: String
        },
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {
            dispatchEvent (dropdownItem, event) {
                if (dropdownItem.disabled !== true) {
                    this.$emit("click", dropdownItem);
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshDropdown.vue